var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsChartDataGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11093_21478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7556 31.7778L18.2111 24.3222L23.1 29.2111L31.7778 20.5944V24.4444H36.6667V12.2222H24.4444V17.1111H28.2944L23.1 22.3056L18.2111 17.4167L7.33334 28.3556L10.7556 31.7778ZM4.88889 44C3.54445 44 2.39311 43.5209 1.43489 42.5627C0.47667 41.6044 -0.00162548 40.4539 4.15016e-06 39.1111V4.88889C4.15016e-06 3.54445 0.479115 2.39311 1.43734 1.43489C2.39556 0.47667 3.54608 -0.00162548 4.88889 4.15016e-06H39.1111C40.4556 4.15016e-06 41.6069 0.479115 42.5651 1.43734C43.5233 2.39556 44.0016 3.54608 44 4.88889V39.1111C44 40.4556 43.5209 41.6069 42.5627 42.5651C41.6044 43.5233 40.4539 44.0016 39.1111 44H4.88889Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11093_21478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsChartDataGrowth);
export default __webpack_public_path__ + "static/media/material-symbols_chart-data_growth.3714c39af8e4f9174e4c37ced9606821.svg";
export { ForwardRef as ReactComponent };